$.valHooks.select.set = function (elem, value) {
    setTimeout(() => {
        const ui = $(elem).data('ui');
        ui && ui.update();

        setTimeout(() => {
            if($(elem).parent().hasClass('ui-input')){
                $(elem).parent().data('ui').changeHandler();
            }
        })
    });
};

$.valHooks.textarea = {
    set: function (elem, value) {
        setTimeout(() => {
            $(elem).trigger('customChange');
        });
    }
};

$.valHooks.input = {
    set: function (elem, value) {
        setTimeout(() => {
            $(elem).trigger('customChange');
        });
    }
};

$.attrHooks.checked = {
    set: function (elem, value) {
        setTimeout(() => {
            $(elem).trigger('customChange');
        });
    }
};

$.propHooks.checked = {
    set: function (elem, value) {
        setTimeout(() => {
            $(elem).trigger('customChange');
        });
    }
};

$.propHooks.disabled = {
    set: function (elem, value) {
        setTimeout(() => {
            $(elem).trigger('customDisabled');
        });
    }
};

function $$(selector){
    return $(selector).data('ui');
}
window.$$ = $$;